import { MODALS }              from '../constants/state-constants';
import * as MixPanel           from '../mixpanel';
import { monthsLeft, daysSinceSubStart }          from '../time-helpers';
import * as Actions            from '../../context/ctx-actions';
import { useGlobalCtx }        from '../../context/ctx-hook';
import { mergeSubscription }   from '../../context/selectors/product-selectors';
import { getUserId }           from '../../context/selectors/user-selectors';
import { callUpdateAutoRenew } from '../../network/network-calls';
import * as ProductSelectors   from '../../context/selectors/product-selectors';


export const useCancelAr = (product) => {
  const {globalDispatch, state} = useGlobalCtx();
  const {expireOn, effectiveAt} = ProductSelectors.getSubscription(state, product);

  const MONTHS_LEFT = monthsLeft(expireOn);
  const DAYS_SINCE_START = daysSinceSubStart(effectiveAt);
  const HAS_ACME = ['acme', 'acme-google', 'acme-apple'].some(prod => state.subscriptions[prod]);
  const IS_USA = state.country === 'us';

  return async () => {
    try {
      globalDispatch(Actions.mergeMainStateObj({modal: {isDisabled: true, hasError: false}}));

      const {data} = await callUpdateAutoRenew({
        product,
        userId:    getUserId(state),
        autoRenew: false
      });

      MixPanel.track(MixPanel.MIX_PANEL_IDS.AUTO_RENEW);
      const SUBSCRIPTIONS = mergeSubscription(state, product, data.postState);

      if (['acme', 'acme-google', 'acme-apple'].includes(product)) {
        globalDispatch(Actions.mergeMainStateObj({
          modal: {
            type:      MODALS.SURVEY,
            surveySrc: 'SIMP_CANCEL_SURVEY',
            ctx:       {product},
            isLoading: true,
            hasError:  false,
            isDisabled: false,
          },
          subscriptions: SUBSCRIPTIONS
        }));
      } else if (IS_USA && !HAS_ACME && ['quicken-us', 'quicken-ca'].includes(product) && DAYS_SINCE_START > 14 && MONTHS_LEFT > 1) {
        globalDispatch(Actions.mergeMainStateObj({
          modal: {
            type:      MODALS.SWITCH_TO_SIMP,
            ctx:       {product},
            isLoading:  false,
            hasError:   false,
            isDisabled: false,
          },
          subscriptions: SUBSCRIPTIONS
        }));
      } else {
        globalDispatch(Actions.mergeMainStateObj({
          modal: {
            type: MODALS.SURVEY,
            surveySrc: 'NO_SWITCH_SIMP_CANCEL_SURVEY',
            ctx: { product },
            isLoading: true,
            hasError: false,
            isDisabled: false,
          },
          subscriptions: SUBSCRIPTIONS
        }));
      }
    } catch (err) {
      MixPanel.error(err, MixPanel.MIX_PANEL_IDS.AUTO_RENEW);
      globalDispatch(Actions.mergeMainStateObj({
        modal: {isDisabled: false, hasError: true}
      }));
    }
  };
};
